import { useEffect } from 'react';
import { parsePromotionAgreedFromState, parseProviderFromState } from '@pocapan/shared/utils/socialAuthWeb';

export default function SocialCallbackPage() {
  useEffect(() => {
    const url = new URL(window.location.href);
    const code = url.searchParams.get('code');
    const stateParam = url.searchParams.get('state');
    const error = url.searchParams.get('error');
    const idToken = url.searchParams.get('id_token');
    const identityToken = url.searchParams.get('identity_token');
    const provider = parseProviderFromState(stateParam);
    const isPromotionAgreed = parsePromotionAgreedFromState(stateParam);

    const nextUrl = new URL('/auth/social/complete', window.location.origin);
    nextUrl.searchParams.set('provider', provider);
    nextUrl.searchParams.set('isPromotionAgreed', isPromotionAgreed ? 'true' : 'false');
    if (code) nextUrl.searchParams.set('code', code);
    if (stateParam) nextUrl.searchParams.set('state', stateParam);
    if (error) nextUrl.searchParams.set('error', error);
    if (idToken) nextUrl.searchParams.set('id_token', idToken);
    if (identityToken) nextUrl.searchParams.set('identity_token', identityToken);

    const deepLink = `pocapan://webview?url=${encodeURIComponent(nextUrl.toString())}`;
    window.location.replace(deepLink);
  }, []);

  return null;
}
